/// <reference path='./global.d.ts'/>
import MetaTags from "react-meta-tags";

import React from "react";
import { MainLayout } from "./components/main-layout/main-layout";
import { AppProperties } from "./components/app-properties/app-properties";
import "./i18n";
import "./App.scss";
import styled from "styled-components";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { config } from "./config";
import { RestaurantError } from "./components/errors/restaurant-error/restaurant-error";
import { createTheme, MuiThemeProvider } from "@material-ui/core";
import { FloatingButton } from "./components/floating-button/floating-button";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { ApiErrorImpl } from "./services/api-errors/api-errors-impl";
import { moduleSettings } from "./stores/module-settings.store";
import { pendingBookingStore } from "./stores/pending-booking.store";
import { Newsletter } from "./components/newsletter/newsletter";

const AppStyle = styled.div`
  color: gray;
`;

const muiTheme = createTheme({
  palette: {
    secondary: {
      main: "#808080",
    },
  },
  overrides: {
    MuiFormLabel: {
      root: {
        fontSize: 12,
      },
    },
    MuiInputLabel: {
      root: {
        fontSize: 12,
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 12,
      },
    },
  },
});

if (process.env.REACT_APP_ENABLED_SENTRY == "true") {
  Sentry.init({
    dsn: process.env.REACT_APP_DSN,
    environment: process.env.REACT_APP_PLATFORM,
    debug: process.env.REACT_APP_ENABLED_SENTRY_DEBUG
      ? process.env.REACT_APP_ENABLED_SENTRY_DEBUG == "true"
      : false,
    release: process.env.REACT_APP_VERSION,
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.5,
    beforeSend(event, hint) {
      event.user = { id: moduleSettings.monitoringUserId };
      let prepayment = pendingBookingStore.pendingBooking.prepayment;
      let ppt = {};
      if (prepayment) {
        ppt = {
          acc: prepayment.stripe_account,
          key: prepayment.stripe_key,
          id: prepayment.intent_id,
          kind: prepayment.kind,
          ppt: prepayment.payment_kind,
        };
      }
      const withoutSentitiveInfo = {
        ...pendingBookingStore.pendingBooking,
        contact_info: {},
        prepayment: {},
        ppt,
      };

      event.contexts = {
        store: { pendingBooking: JSON.stringify(withoutSentitiveInfo) },
      };
      if (
        hint.originalException &&
        hint.originalException instanceof ApiErrorImpl
      )
        if (
          event.exception &&
          event.exception.values &&
          event.exception.values.length == 1 &&
          event.exception.values[0].value
        )
          event.exception.values[0].value = (
            hint.originalException as ApiErrorImpl
          ).code;
      return event;
    },
  });
}

function App() {
  return (
    <MuiThemeProvider theme={muiTheme}>
      <MetaTags>
        <meta name="robots" content="noindex" />
      </MetaTags>
      <AppStyle>
        <Router>
          <Switch>
            <Route path="/__version__">
              <AppProperties />
            </Route>
            <Route path={config.routes.floatingButton}>
              <FloatingButton></FloatingButton>
            </Route>
            <Route path={config.routes.newsletter}>
              <Newsletter />
            </Route>
            <Route path={config.routes.url}>
              <MainLayout />
            </Route>
            <Route>
              <RestaurantError />
            </Route>
          </Switch>
        </Router>
      </AppStyle>
    </MuiThemeProvider>
  );
}

export default Sentry.withProfiler(App);
